import { Cell, Workbook, Worksheet } from "exceljs";
import { ExcelJSBase } from "../../../../../services/exceljs.service";
import { logoBase64 } from "../../../info-technology-process/repair-tools/base64";
import { DateHelper, StringHelper } from "../../../../../helper";
import { DepartmentCode } from "../../../../../constants";
import { getValueWithKeyword } from "../../monthly-training-plan-summary/components";

export class MTPExcelJSService extends ExcelJSBase {
  create(data: any[]): Workbook {
    const tsnItems = data.filter((item) => {
      const departmentCode = StringHelper.verticalBarSplit<string[]>(
        item.eTitle
      )[0];
      return departmentCode === DepartmentCode.TSN;
    });
    const nbItems = data.filter((item) => {
      const departmentCode = StringHelper.verticalBarSplit<string[]>(
        item.eTitle
      )[0];
      return departmentCode === DepartmentCode.NB;
    });
    const dnItems = data.filter((item) => {
      const departmentCode = StringHelper.verticalBarSplit<string[]>(
        item.eTitle
      )[0];
      return departmentCode === DepartmentCode.DN;
    });
    const kcqItems = data.filter((item) => {
      const departmentCode = StringHelper.verticalBarSplit<[DepartmentCode]>(
        item.eTitle
      )[0];
      return ![
        DepartmentCode.TSN,
        DepartmentCode.NB,
        DepartmentCode.DN,
      ].includes(departmentCode);
    });

    const test = [
      {
        sheetName: "TSN",
        data: tsnItems,
      },
      {
        sheetName: "NB",
        data: nbItems,
      },
      {
        sheetName: "DN",
        data: dnItems,
      },
      {
        sheetName: "KCQ",
        data: kcqItems,
      },
    ];

    test.forEach((item) => {
      if (item.data.length > 0) {
        const worksheet = this.addWorksheet(item.sheetName);
        this.configColumn(worksheet);
        this.header(worksheet);
        this.tableHeader(worksheet);
        this.createDepartmentRow(worksheet, item.data);
        this.footer(worksheet);
      }
    });

    return this.workbook;
  }
  configColumn(worksheet: Worksheet) {
    const bCol = worksheet.getColumn("B");
    const cCol = worksheet.getColumn("C");
    const eCol = worksheet.getColumn("E");
    const fCol = worksheet.getColumn("F");
    const jCol = worksheet.getColumn("J");
    const kCol = worksheet.getColumn("K");
    const nCol = worksheet.getColumn("N");
    const oCol = worksheet.getColumn("O");
    bCol.width = 35;
    cCol.width = 25;
    eCol.width = 18;
    fCol.width = 20;
    jCol.width = 18;
    kCol.width = 18;
    nCol.width = 25;
    oCol.width = 25;
  }
  header(worksheet: Worksheet) {
    const imageId = this.addImage({
      base64: logoBase64,
      extension: "png",
    });

    this.addRow(worksheet, [
      {
        text: "Biểu mẫu",
        from: 2,
        options: { font: { italic: true, bold: true } },
      },
      {
        text: "Mã số: V.TMM-F22",
        from: 13,
        options: { font: { bold: true } },
      },
    ]);
    this.addRow(worksheet, [
      {
        text: "KẾ HOẠCH ĐÀO TẠO",
        from: 2,
        options: {
          font: { size: 14, bold: true },
          alignment: { horizontal: "center", vertical: "middle" },
        },
      },
      { text: "Ban hành: 04", from: 13, options: { font: { bold: true } } },
    ]);
    this.addRow(worksheet, [
      {
        text: "Hiệu lực: 01/12/2022",
        from: 13,
        options: { font: { bold: true } },
      },
    ]);

    this.addRow(worksheet, [
      { text: "Trang: 1/1", from: 13, options: { font: { bold: true } } },
    ]);

    this.addRow(worksheet, []);

    worksheet.addImage(imageId, "A1:B4");

    worksheet.mergeCells("A1:B4");
    worksheet.mergeCells("C2:M3");
  }
  tableHeader(worksheet: Worksheet) {
    const options: Partial<Cell> = {
      font: { bold: true },
      alignment: { horizontal: "center", vertical: "middle" },
    };

    this.addRow(worksheet, [
      { text: "STT", from: 0, options },
      { text: "Khóa đào tạo", from: 1, options },
      { text: "Loại hình đào tạo", from: 2, options },
      { text: "Số lượng học viên", from: 3, options },
      { text: "Đối tượng", from: 5, options },
      { text: "Thời lượng", from: 6, options },
      { text: "Thời gian", from: 9, options },
      { text: "Địa điểm", from: 11, options },
      { text: "Giáo viên/Đối tác", from: 13, options },
      { text: "Ghi chú", from: 14, options },
    ]);
    this.addRow(worksheet, [
      { text: "Viags", from: 3, options },
      { text: "VNA/Bên ngoài", from: 4, options },
      { text: "EL", from: 6, options },
      { text: "TT", from: 7, options },
      { text: "TH", from: 8, options },
      { text: "Từ ngày", from: 9, options },
      { text: "Đến ngày", from: 10, options },
      { text: "TN", from: 11, options },
      { text: "NN", from: 12, options },
    ]);

    worksheet.mergeCells("A6:A7");
    worksheet.mergeCells("B6:B7");
    worksheet.mergeCells("C6:C7");
    worksheet.mergeCells("D6:E6");
    worksheet.mergeCells("F6:F7");
    worksheet.mergeCells("G6:I6");
    worksheet.mergeCells("J6:K6");
    worksheet.mergeCells("L6:M6");
    worksheet.mergeCells("N6:N7");
    worksheet.mergeCells("O6:O7");
  }
  createDepartmentRow(
    worksheet: Worksheet,
    data: { eTitle: string; children: any[] }[]
  ) {
    data.forEach((item, index) => {
      const departmentName = StringHelper.verticalBarSplit<string[]>(
        item.eTitle
      )[1];
      this.addRow(worksheet, [
        {
          text: StringHelper.intToChar(index, true),
          from: 0,
          options: {
            font: { bold: true },
            alignment: { horizontal: "center", vertical: "middle" },
          },
        },
        { text: departmentName, from: 1, options: { font: { bold: true } } },
      ]);
      this.createTrainingCourseRow(worksheet, item.children);
    });
  }
  createTrainingCourseRow(
    worksheet: Worksheet,
    data: { eTitle: string; children: any[] }[]
  ) {
    data.forEach((item, index) => {
      this.addRow(worksheet, [
        {
          text: StringHelper.intToRoman(index + 1),
          from: 0,
          options: {
            font: { bold: true },
            alignment: { horizontal: "center", vertical: "middle" },
          },
        },
        { text: item.eTitle, from: 1, options: { font: { bold: true } } },
      ]);
      this.createMajorRow(worksheet, item.children);
    });
  }
  createMajorRow(
    worksheet: Worksheet,
    data: { eTitle: string; children: any[] }[]
  ) {
    data.forEach((item, index) => {
      this.addRow(worksheet, [
        {
          text: StringHelper.intToChar(index),
          from: 0,
          options: {
            font: { bold: true },
            alignment: { horizontal: "center", vertical: "middle" },
          },
        },
        { text: item.eTitle, from: 1, options: { font: { bold: true } } },
      ]);
      this.createSubjectRow(worksheet, item.children);
    });
  }
  createSubjectRow(worksheet: Worksheet, data: any[]) {
    data.forEach((item, index) => {
      this.addRow(worksheet, [
        {
          text: (index + 1).toString(),
          from: 0,
          options: { alignment: { horizontal: "center", vertical: "middle" } },
        }, // STT
        { text: item.eSubject, from: 1 }, // Khóa đào tạo
        {
          text: item.eTrainingType,
          from: 2,
          options: { alignment: { horizontal: "center", vertical: "middle" } },
        }, // Loại hình đào tạo
        {
          text: getValueWithKeyword(item.eTrainees, "VIAGS"),
          from: 3,
          options: { alignment: { horizontal: "center", vertical: "middle" } },
        }, // Viags
        {
          text: getValueWithKeyword(item.eTrainees, "VNA"),
          from: 4,
          options: { alignment: { horizontal: "center", vertical: "middle" } },
        }, // VNA/Bên ngoài
        {
          text: item.eTraineeObject,
          from: 5,
          options: { alignment: { horizontal: "center", vertical: "middle" } },
        }, // Đối tượng
        {
          text: getValueWithKeyword(item.eLessonTypes, "EL"),
          from: 6,
          options: { alignment: { horizontal: "center", vertical: "middle" } },
        }, // EL
        {
          text: getValueWithKeyword(item.eLessonTypes, "TT"),
          from: 7,
          options: { alignment: { horizontal: "center", vertical: "middle" } },
        }, // TT
        {
          text: getValueWithKeyword(item.eLessonTypes, "TH"),
          from: 8,
          options: { alignment: { horizontal: "center", vertical: "middle" } },
        }, // TT
        {
          text: DateHelper.formatDateToString(item.eDateTime[0]),
          from: 9,
          options: { alignment: { horizontal: "center", vertical: "middle" } },
        }, // Từ ngày
        {
          text: DateHelper.formatDateToString(item.eDateTime[1]),
          from: 10,
          options: { alignment: { horizontal: "center", vertical: "middle" } },
        }, // Đến ngày
        {
          text: getValueWithKeyword(item.eCoursePlaces, "TN"),
          from: 11,
          options: { alignment: { horizontal: "center", vertical: "middle" } },
        }, // TN
        {
          text: getValueWithKeyword(item.eCoursePlaces, "NN"),
          from: 12,
          options: { alignment: { horizontal: "center", vertical: "middle" } },
        }, // NN
        {
          text: item.eCourseTrainee,
          from: 13,
          options: { alignment: { horizontal: "center", vertical: "middle" } },
        }, // Giáo viên/Đối tác
        { text: item.eNotes, from: 14 }, // Ghi chú
      ]);
    });
  }
  footer(worksheet: Worksheet) {
    this.addRow(worksheet, [
      {
        text: "Phòng Tổ chức và Nhân lực:",
        from: 0,
        options: { font: { bold: true } },
      },
      {
        text: "Trưởng Trung tâm Đào tạo:",
        from: 3,
        options: { font: { bold: true } },
      },
      { text: "Tổng Giám đốc:", from: 11, options: { font: { bold: true } } },
    ]);
    this.addRow(worksheet, []);
    this.addRow(worksheet, []);
    this.addRow(worksheet, []);
    this.addRow(worksheet, []);
    this.addRow(worksheet, []);
    this.addRow(worksheet, []);
    this.addRow(worksheet, []);
    this.addRow(worksheet, [
      { text: "Ngày", from: 0, options: { font: { bold: true } } },
      { text: "Ngày", from: 3, options: { font: { bold: true } } },
      { text: "Ngày", from: 11, options: { font: { bold: true } } },
    ]);
    this.addRow(worksheet, [
      { text: "Họ tên: ", from: 0, options: { font: { bold: true } } },
      { text: "Họ tên: ", from: 3, options: { font: { bold: true } } },
      { text: "Họ tên: ", from: 11, options: { font: { bold: true } } },
    ]);
  }
}
